import Service, { service } from '@ember/service';
import { camelize } from '@ember/string';
import { task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';

import { query as emberDataQuery } from '@ember-data/legacy-compat/builders';

export default class WorkInstructionCacheService extends Service {
  @service store;

  perPage = 30;
  cachedWorkInstructions = [];

  constructor() {
    super(...arguments);
    this.setupAsync.perform();
  }

  setupAsync = task(waitFor(async () => {
    this.cachedWorkInstructions = [];

    //NOTE: this preloading doesn't do any good for work instructions in folders
    await this.queryInstructions.perform({ pageNumber: 1 });
  }));

  queryInstructions = task({ enqueue: true }, waitFor(async query => {
    query.folder ??= 'noFolder';
    query.searchTerm ??= null;
    const { searchTerm, pageNumber, folder } = query;

    const cacheKey = camelize(searchTerm + folder + pageNumber + this.perPage);
    const cachedResult = this.cachedWorkInstructions.find(item => item.cacheKey === cacheKey);

    if (cachedResult) {
      return cachedResult;
    }

    this.cachedWorkInstructions = this.cachedWorkInstructions.filter(item => item.cacheKey !== cacheKey);

    query.perPage = this.perPage;
    const {
      content: instructions,
    } = await this.store.request(emberDataQuery('work-instruction', query));

    const result = {
      cacheKey,
      searchTerm,
      folder,
      pageNumber,
      perPage: this.perPage,
      instructions: [...instructions],
      count: instructions?.meta?.count ?? 0,
    };

    this.cachedWorkInstructions.push(result);

    return result;
  }));
}
